export default {
  pt: {
    'form.campoSenhaForte.show': 'Mostrar senha',
    'form.campoSenhaForte.hide': 'Ocultar senha',
    'form.campoSenhaForte.level.fraca': 'Senha fraca',
    'form.campoSenhaForte.level.media': 'Senha média',
    'form.campoSenhaForte.level.forte': 'Senha forte',
    'form.campoSenhaForte.minLength': 'Pelo menos {{minimo}} caracteres',
    'form.campoSenhaForte.mixTypes': 'Combine ao menos {{exigidas}} tipos entre {{tipos}}',
    'form.campoSenhaForte.classUppercase': 'maiúscula',
    'form.campoSenhaForte.classLowercase': 'minúscula',
    'form.campoSenhaForte.classNumber': 'número',
    'form.campoSenhaForte.classSymbol': 'símbolo',
    'form.campoSenhaForte.tooPredictable': 'Esta senha tem um trecho previsível demais. Escolha outra combinação.',
    'form.campoSenhaForte.personalData': 'A senha não pode conter o seu nome nem o seu e-mail.',
  },
  en: {
    'form.campoSenhaForte.show': 'Show password',
    'form.campoSenhaForte.hide': 'Hide password',
    'form.campoSenhaForte.level.fraca': 'Weak password',
    'form.campoSenhaForte.level.media': 'Medium password',
    'form.campoSenhaForte.level.forte': 'Strong password',
    'form.campoSenhaForte.minLength': 'At least {{minimo}} characters',
    'form.campoSenhaForte.mixTypes': 'Combine at least {{exigidas}} types among {{tipos}}',
    'form.campoSenhaForte.classUppercase': 'uppercase',
    'form.campoSenhaForte.classLowercase': 'lowercase',
    'form.campoSenhaForte.classNumber': 'number',
    'form.campoSenhaForte.classSymbol': 'symbol',
    'form.campoSenhaForte.tooPredictable': 'This password contains a predictable sequence. Choose another combination.',
    'form.campoSenhaForte.personalData': 'The password cannot contain your name or your email.',
  },
  es: {
    'form.campoSenhaForte.show': 'Mostrar contraseña',
    'form.campoSenhaForte.hide': 'Ocultar contraseña',
    'form.campoSenhaForte.level.fraca': 'Contraseña débil',
    'form.campoSenhaForte.level.media': 'Contraseña media',
    'form.campoSenhaForte.level.forte': 'Contraseña fuerte',
    'form.campoSenhaForte.minLength': 'Al menos {{minimo}} caracteres',
    'form.campoSenhaForte.mixTypes': 'Combine al menos {{exigidas}} tipos entre {{tipos}}',
    'form.campoSenhaForte.classUppercase': 'mayúscula',
    'form.campoSenhaForte.classLowercase': 'minúscula',
    'form.campoSenhaForte.classNumber': 'número',
    'form.campoSenhaForte.classSymbol': 'símbolo',
    'form.campoSenhaForte.tooPredictable': 'Esta contraseña tiene una secuencia demasiado previsible. Elija otra combinación.',
    'form.campoSenhaForte.personalData': 'La contraseña no puede contener su nombre ni su correo.',
  },
}
